<template>
  <Component
    :is="is"
    class="card-integration"
    v-bind="params"
  >
    <div class="logo">
      <UiComponentImage
        v-if="!!integration.logo"
        :alt="integration.name"
        :expected-size="40"
        :height="integration.logo.height"
        :source="integration.logo.url"
        :width="integration.logo.width"
      />
    </div>
    <div class="info">
      <UiComponentParagraph
        class="category"
        size="s"
      >
        {{
          integration.category
        }}
      </UiComponentParagraph>
      <UiComponentHeading :level="3">
        {{ integration.name }}
      </UiComponentHeading>
      <UiComponentParagraph class="description">
        {{
          integration.description
        }}
      </UiComponentParagraph>
    </div>
  </Component>
</template>

<script setup>
// Composables
const localePath = useLocalePath()

// Props
const props = defineProps({
  integration: {
    required: true,
    type: Object,
  },
})

// Computed Properties
const is = computed(() => {
  if (!props.to) {
    return 'div'
  }

  return resolveComponent('NuxtLink')
})

const params = computed(() => {
  if (props.to) {
    return {
      to: props.to,
    }
  }

  return {}
})

const to = computed(() => {
  if (props.integration.slug) {
    return localePath({
      name: 'integrations-slug',
      params: { slug: props.integration.slug },
    })
  }

  return undefined
})
</script>

<style lang="postcss" scoped>
.card-integration {
  @apply flex flex-row w-full p-6 rounded-4xl border border-grey-blue-200 transform transition-transform ease-out duration-500;

  @screen md {
    @apply p-8;
  }

  .logo {
    @apply flex-shrink-0 self-center w-auto;

    @screen md {
      @apply self-start;
    }

    picture {
      @apply rounded-none;
    }
  }

  .info {
    @apply flex flex-col order-first mr-8;

    @screen lg {
      @apply order-last ml-8;
    }

    .category {
      @apply text-livestorm-blue-600 font-medium;
    }

    .h3 {
      @apply mt-1 font-medium text-xl leading-7;

      @screen mdminus {
        @apply text-2xl leading-8;
      }

      @screen mdplus {
        @apply text-2xl leading-8;
      }
    }

    .description {
      @apply mt-2 text-grey-blue-700;
    }
  }
}

a:hover {
  transform: scale(1.02);
}
</style>
